'use client';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoLink from 'eco-design/base/eco-link';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import './index.scss';

export default function Content({ id, data, attr, initIndex = 0, isEditStatus = false }: any) {
    const prefixCls = 'editor-blog-banner-swiper';
    const { isAutoPlay, list = [] } = data;
    const dataLayerA = {
        event: 'uaEvent',
        event_name: 'jump_button',
        button_name: 'blog_banner',
        __btn_id1: `editor-blog-banner-swiper`,
        __btn_type: 'href',
    };

    return (
        <div
            className={`editor-blog-banner-swiper temp-hide temp-${id} GtmModuleData-section`}
            id={id}
            data-section-id="editor-blog-banner-swiper"
            data-section-id2={id}
            data-section-title="index banner"
        >
            <Swiper
                modules={[Scrollbar, Navigation, Pagination, Autoplay]}
                navigation={true}
                pagination={true}
                loop={!!isAutoPlay && list.length > 1}
                autoplay={!!isAutoPlay && list.length > 1 ? { delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true } : false}
                slidesPerView={'auto'}
                initialSlide={initIndex || 0}
            >
                {list.map((item: any, index: number) => {
                    const dataLayerB = {
                        ...dataLayerA,
                        position: `blog_banner_swiper_${index + 1}`,
                        url: item.linkMore,
                        __btn_id2: item.linkMore,
                    };
                    return (
                        <SwiperSlide key={index} className={`${prefixCls}-item`}>
                            <EcoLink href={item.linkMore} className={`${prefixCls}-item-link GtmModuleData-btn-href`} dataLayer={dataLayerB}>
                                <EcoImgVideo isVideo={item.isVideo} pc={item.pc} h5={item.h5} className={`${prefixCls}-img`} />
                            </EcoLink>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}
